/* @jsx h */
import { labels, pluginNamespace } from '../config';
import { useRef, useEffect, useState } from 'preact/hooks';

const Header = ({ query }) => {
  const [searchQuery, setSearchQuery] = useState(query);
  const searchInputEl = useRef(null);

  useEffect(() => setSearchQuery(query), [query]);

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setSearchQuery(value);
    }
  }

  return (
    <div class="search-global">
      <div className="search-global__input-wrapper">
        <input
          type="text"
          className="search-global__input"
          placeholder={labels.search.placeholder || ''}
          name={`${pluginNamespace}[q]`}
          value={searchQuery}
          ref={searchInputEl}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </div>
      <button className="search-global__button" type="submit">
        {labels.search.submit}
        <span class="icon icon--magnifier">
          <svg
            class="icon__svg"
            focusable="false"
            role="img"
            aria-hidden="true"
          >
            <use href="#icon-magnifier" />
          </svg>
        </span>
      </button>
    </div>
  );
};

export default Header;
